<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-config icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          System Settings
          <div class="page-title-subheading">Configure system-wide settings for the portal.</div>
        </div>
      </div>
    </div>
  </div>

  <!-- WhatsApp Configuration card -->
  <div class="card mb-3">
    <div class="card-header d-flex align-items-center gap-2">
      <i class="pe-7s-phone icon-gradient bg-mean-fruit" style="font-size:1.1rem;"></i>
      <span class="fw-semibold">WhatsApp Configuration</span>
    </div>
    <div class="card-body">

      <!-- Loading -->
      <div *ngIf="isLoadingClientInfo" class="text-muted d-flex align-items-center gap-2" style="font-size:0.88rem;">
        <span class="spinner-border spinner-border-sm"></span> Loading configuration...
      </div>

      <!-- Error -->
      <div *ngIf="!isLoadingClientInfo && clientInfoError" class="alert alert-danger py-2 px-3 mb-0" style="font-size:0.85rem;">
        <i class="pe-7s-attention me-1"></i>{{ clientInfoError }}
      </div>

      <!-- Info fields -->
      <div *ngIf="!isLoadingClientInfo && !clientInfoError" class="client-info-grid">

        <!-- Phone Number ID -->
        <div class="client-info-row">
          <div class="client-info-label">
            Phone Number ID
            <span class="client-info-hint">Your WhatsApp Business phone number identifier (Meta's API)</span>
          </div>
          <div class="client-info-value-wrap">
            <input type="text" class="form-control client-info-input" [value]="phoneNoId || '—'" readonly />
            <button class="btn client-copy-btn"
              [class.btn-outline-secondary]="!copyPhoneSuccess"
              [class.btn-success]="copyPhoneSuccess"
              (click)="copyToClipboard(phoneNoId, 'phone')"
              [disabled]="!phoneNoId"
              title="Copy Phone Number ID">
              <i [class]="copyPhoneSuccess ? 'pe-7s-check' : 'pe-7s-copy-file'"></i>
              {{ copyPhoneSuccess ? 'Copied!' : 'Copy' }}
            </button>
          </div>
        </div>

        <!-- WABA ID -->
        <div class="client-info-row">
          <div class="client-info-label">
            WhatsApp Business Account ID
            <span class="client-info-hint">Your WABA ID — used when creating flows and templates via Meta's API</span>
          </div>
          <div class="client-info-value-wrap">
            <input type="text" class="form-control client-info-input" [value]="wabaId || '—'" readonly />
            <button class="btn client-copy-btn"
              [class.btn-outline-secondary]="!copyWabaSuccess"
              [class.btn-success]="copyWabaSuccess"
              (click)="copyToClipboard(wabaId, 'waba')"
              [disabled]="!wabaId"
              title="Copy WABA ID">
              <i [class]="copyWabaSuccess ? 'pe-7s-check' : 'pe-7s-copy-file'"></i>
              {{ copyWabaSuccess ? 'Copied!' : 'Copy' }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Welcome message card -->
  <div class="mb-3 card">
    <div class="card-header d-flex align-items-center gap-2">
      <i class="pe-7s-chat icon-gradient bg-mean-fruit" style="font-size:1.1rem;"></i>
      <span class="fw-semibold">Welcome Message</span>
    </div>
    <div class="card-body">
      <p class="text-muted mb-3" style="font-size:0.88rem;">
        Customise the automatic greeting sent to users when they first message your WhatsApp number.
      </p>
      <button type="button" class="btn btn-primary" (click)="openWelcomeMessageModal()">
        Configure Welcome Message
      </button>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="welcomeMessageModal"
  tabindex="-1"
  aria-labelledby="welcomeMessageModalLabel"
  aria-hidden="true"
  #welcomeMessageModal
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="welcomeMessageModalLabel">Configure Welcome Message</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

        <div *ngIf="isLoadingSettings" class="text-center text-muted py-4">Loading...</div>

        <div *ngIf="!isLoadingSettings && !selectedAudience" class="d-flex flex-column gap-2">
          <button type="button" class="btn btn-outline-primary text-start" (click)="selectAudience('registered')">
            For Registered Users
          </button>
          <button type="button" class="btn btn-outline-primary text-start" (click)="selectAudience('nonRegistered')">
            For Non-Registered Users
          </button>
        </div>

        <div *ngIf="!isLoadingSettings && selectedAudience">
          <label class="form-label" for="welcomeMessageText">
            Welcome Message for {{ selectedAudience === 'registered' ? 'Registered' : 'Non-Registered' }} Users
          </label>
          <textarea
            id="welcomeMessageText"
            #welcomeMessageTextarea
            class="form-control"
            rows="6"
            name="welcomeMessageText"
            [(ngModel)]="messageDraft"
          ></textarea>

          <ng-container *ngIf="selectedAudience === 'registered'">
            <div class="form-text mt-2">
              e.g. Welcome <span class="token-highlight">{{ '{{' }}empName{{ '}}' }}</span> or
              <span class="token-highlight">*{{ '{{' }}empNo{{ '}}' }}*</span>
            </div>

            <div class="mt-3">
              <div class="mb-1 text-muted small">Insert Employee Master field:</div>
              <div class="d-flex flex-wrap gap-2">
                <button
                  *ngFor="let field of employeeFieldTokens"
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  [title]="'Insert ' + field.label"
                  (click)="insertToken(field.token)"
                >
                  {{ field.label }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="selectedAudience" type="button" class="btn btn-secondary" (click)="backToOptions()">Back</button>
        <button *ngIf="!selectedAudience" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button
          *ngIf="selectedAudience"
          type="button"
          class="btn btn-primary"
          [disabled]="isSaving"
          (click)="saveWelcomeMessage()"
        >
          {{ isSaving ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</div>
